import { render, staticRenderFns } from "./a-time.vue?vue&type=template&id=0991db40&scoped=true"
import script from "./a-time.vue?vue&type=script&lang=js"
export * from "./a-time.vue?vue&type=script&lang=js"
import style0 from "./a-time.vue?vue&type=style&index=0&id=0991db40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991db40",
  null
  
)

export default component.exports